<template>
  <div class="main" @click="imgClick">
    <div v-for="(item, index) in productinfo" :key="index">
      <van-image
        :width="imgwidth"
        :height="imgheight"
        fit="fill"
        round
        lazy-load
        :src="imgsrc"
      />
      <div class="name">{{ item.GoodsName }}</div>
      <div class="tips">{{ item.GoodsMoney }}</div>
    </div>
  </div>
</template>

<script>
import { Lazyload } from "vant";
export default {
  methods: {
    imgClick() {
      this.$emit("imgClick");
    },
  },
  props: {
    name: {
      type: String,
      default: "www",
    },
    tips: {
      type: String,
      default: "aaa",
    },
    imgwidth: {
      type: Number,
      default: 100,
    },
    imgheight: {
      type: Number,
      default: 100,
    },
    imgsrc: {
      type: String,
      default: "https://img01.yzcdn.cn/vant/cat.jpeg",
    },
    productinfo: {
      type: Array,
      default() {
        return [];
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  display: flex;
  flex-direction: column;
  margin: 5vw;
  .name {
    width: 100px;
    text-align: center;
  }
  .tips {
    width: 100px;
    text-align: center;
  }
}
</style>